import React, {useEffect} from "react";
import {useQuery} from "react-query";
import {getConfig} from "Api/Query/ConfigQuery";

interface Props{
    width?: number|string
}

const Triptico: React.FC<Props> = (props) => {

    const [tripticoUrl, setTripticoUrl] = React.useState<string>("")
    const [tripticoFile, setTripticoFile] = React.useState<string>("")

    const getTripticoImageQuery = useQuery({
        enabled: false,
        queryKey: ['tripticoImageConfig'],
        queryFn: () => getConfig('app.triptico_img_url'),
        onSuccess: (response: any) => {
            const item = response.data?._result;

            if (item?.value) {
                setTripticoUrl(item.value)
            }
        }
    })

    const getTripticoFileQuery = useQuery({
        enabled: false,
        queryKey: ['tripticoFileConfig'],
        queryFn: () => getConfig('app.triptico_file_url'),
        onSuccess: (response: any) => {
            const item = response.data?._result;

            if (item?.value) {
                setTripticoFile(item.value)
            }
        }
    })

    useEffect(() => {
        getTripticoImageQuery.refetch();
        getTripticoFileQuery.refetch();
    }, []);

    return (
        <>
            {
                tripticoUrl && tripticoFile &&
                <a href={tripticoFile} target={"_blank"} className={"mt-4 mt-sm-0"}>
                    <img
                        src={tripticoUrl}
                        alt={"Plan Sanse Concilia"}
                        title={"Plan Sanse Concilia"}
                        style={props.width ? {width: props.width} : {maxHeight: '120px'}}
                    />
                </a>
            }
        </>
    );
};

export default Triptico;
